import * as React from 'react';

export const IconChevronDown = React.forwardRef<
  SVGSVGElement,
  React.ComponentProps<'svg'>
>(function IconChevronDown(props, ref): JSX.Element {
  return (
    <svg
      ref={ref}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 9L12 15L18 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
